import * as React from 'react'
import styled from '@emotion/styled'
import { DEFAULT_FONT_STYLES } from 'css/theme'
import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import LoadingSpinnerComponent from './LoadingSpinner'

export const LoadingFullContainer = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.8);
`

export const LoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  backdrop-filter: blur(8px);
`

export const LoadingTitle = styled.div({
  width: '352px',
  height: '32px',
  marginBottom: '12px',
  fontWeight: DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-weight'],
  fontSize: DEFAULT_FONT_STYLES['--theme-font--title-page__font-size'],
  lineHeight: DEFAULT_FONT_STYLES['--theme-font--title-page__line-height'],
})

export const LoadingSubTitle = styled.div({
  height: '24px',
  marginBottom: '8px',
  fontWeight: DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-weight'],
  fontSize: DEFAULT_FONT_STYLES['--theme-font--body-default__font-size'],
  lineHeight: DEFAULT_FONT_STYLES['--theme-font--body-lg__line-height'],
})

export const LoadingContent = styled.div({
  width: '352px',
  height: '48px',
  marginBottom: '64px',
  fontWeight: DEFAULT_FONT_STYLES['--theme-font--body-default__font-weight'],
  fontSize: DEFAULT_FONT_STYLES['--theme-font--body-default__font-size'],
  lineHeight: DEFAULT_FONT_STYLES['--theme-font--body-lg__line-height'],
})

const Loading = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const preventInteraction = (event: KeyboardEvent) => {
      event.preventDefault()
      return false
    }

    window.addEventListener('keydown', preventInteraction)

    return () => {
      window.removeEventListener('keydown', preventInteraction)
    }
  }, [])

  return (
    <LoadingFullContainer>
      <LoadingContainer>
        <LoadingSpinnerComponent />
        <LoadingTitle>{t('Loading.processingYourPayment', 'Processing your payment')}</LoadingTitle>
        <LoadingSubTitle>
          {t('Loading.pleaseDoNotLeaveOrRefresh', 'Please do not leave or refresh the page.')}
        </LoadingSubTitle>
        <LoadingContent>
          {t(
            'Loading.onceYourDonationIsComplete',
            'Once your donation is complete, you&apos;ll be taken to a summary and email receipt.',
          )}
        </LoadingContent>
      </LoadingContainer>
    </LoadingFullContainer>
  )
}

export default Loading
